import React from "react";

const isMobile = false;

export default React.createContext(isMobile);
